module.exports = __webpack_public_path__ + "static/media/invoice_card.70fe586f.png";


//////////////////
// WEBPACK FOOTER
// ./src/presentation/assets/img/invoice_card.png
// module id = 511
// module chunks = 0